module.exports = {
  'CHINESE': require('./chinese'),
  'ENGLISH': require('./english'),
  'FRENCH': require('./french'),
  'ITALIAN': require('./italian'),
  'JAPANESE': require('./japanese'),
  'SPANISH': require('./spanish')
}
